import {Construtor} from './construtor';
import {RotinaCliente} from './rotina-cliente';
import {CriterioAvaliacaoRotinaCliente} from './criterio-avaliacao-rotina-cliente';

export class ConfigOcorrenciaAuto implements Construtor<ConfigOcorrenciaAuto> {

  public idConfigOcorrenciaAuto: number;
  public rotinaCliente: RotinaCliente;
  public criterioAvaliacaoRotinaCliente: CriterioAvaliacaoRotinaCliente;
  public idCliente: number;
  public idUsuario: number;
  public conteudoEmail: string;
  public idUsuarioPrimeiraAlcada: number;
  public numeroHorasPrimeiraAlcada: number;
  public conteudoEmailPrimeiraAlcada: string;
  public idUsuarioSegundaAlcada: number;
  public numeroHorasSegundaAlcada: number;
  public conteudoEmailSegundaAlcada: string;
  public idUsuarioTerceiraAlcada: number;
  public numeroHorasTerceiraAlcada: number;
  public conteudoEmailTerceiraAlcada: string;
  public dataAteReincidencia: Date;

  constructor(object?: any) {
    this.rotinaCliente = new RotinaCliente();
    this.criterioAvaliacaoRotinaCliente = new CriterioAvaliacaoRotinaCliente();
    if (object !== undefined) {
      if (object instanceof (ConfigOcorrenciaAuto)) {
        this.copyObject(object);
      } else if (object instanceof RotinaCliente) {
        this.rotinaCliente = new RotinaCliente(object);
      } else if (object instanceof CriterioAvaliacaoRotinaCliente) {
        this.criterioAvaliacaoRotinaCliente = new CriterioAvaliacaoRotinaCliente(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(configOcorrenciaAuto: any): void {
    this.idConfigOcorrenciaAuto = configOcorrenciaAuto.idConfigOcorrenciaAuto;
    this.rotinaCliente = configOcorrenciaAuto.rotinaCliente;
    this.criterioAvaliacaoRotinaCliente = configOcorrenciaAuto.criterioAvaliacaoRotinaCliente;
    this.idCliente = configOcorrenciaAuto.idCliente;
    this.idUsuario = configOcorrenciaAuto.idUsuario;
    this.idUsuarioPrimeiraAlcada = configOcorrenciaAuto.idUsuarioPrimeiraAlcada;
    this.idUsuarioSegundaAlcada = configOcorrenciaAuto.idUsuarioSegundaAlcada;
    this.idUsuarioTerceiraAlcada = configOcorrenciaAuto.idUsuarioTerceiraAlcada;
    this.numeroHorasPrimeiraAlcada = configOcorrenciaAuto.numeroHorasPrimeiraAlcada;
    this.numeroHorasSegundaAlcada = configOcorrenciaAuto.numeroHorasSegundaAlcada;
    this.numeroHorasTerceiraAlcada = configOcorrenciaAuto.numeroHorasTerceiraAlcada;
    this.conteudoEmail = configOcorrenciaAuto.conteudoEmail;
    this.conteudoEmailPrimeiraAlcada = configOcorrenciaAuto.conteudoEmailPrimeiraAlcada;
    this.conteudoEmailSegundaAlcada = configOcorrenciaAuto.conteudoEmailSegundaAlcada;
    this.conteudoEmailTerceiraAlcada = configOcorrenciaAuto.conteudoEmailTerceiraAlcada;
    this.dataAteReincidencia = configOcorrenciaAuto.dataAteReincidencia;
  }

  copyObject(configOcorrenciaAuto: ConfigOcorrenciaAuto): void {
    this.idConfigOcorrenciaAuto = configOcorrenciaAuto.idConfigOcorrenciaAuto;
    this.rotinaCliente = configOcorrenciaAuto.rotinaCliente;
    this.criterioAvaliacaoRotinaCliente = configOcorrenciaAuto.criterioAvaliacaoRotinaCliente;
    this.idCliente = configOcorrenciaAuto.idCliente;
    this.idUsuario = configOcorrenciaAuto.idUsuario;
    this.idUsuarioPrimeiraAlcada = configOcorrenciaAuto.idUsuarioPrimeiraAlcada;
    this.idUsuarioSegundaAlcada = configOcorrenciaAuto.idUsuarioSegundaAlcada;
    this.idUsuarioTerceiraAlcada = configOcorrenciaAuto.idUsuarioTerceiraAlcada;
    this.numeroHorasPrimeiraAlcada = configOcorrenciaAuto.numeroHorasPrimeiraAlcada;
    this.numeroHorasSegundaAlcada = configOcorrenciaAuto.numeroHorasSegundaAlcada;
    this.numeroHorasTerceiraAlcada = configOcorrenciaAuto.numeroHorasTerceiraAlcada;
    this.conteudoEmail = configOcorrenciaAuto.conteudoEmail;
    this.conteudoEmailPrimeiraAlcada = configOcorrenciaAuto.conteudoEmailPrimeiraAlcada;
    this.conteudoEmailSegundaAlcada = configOcorrenciaAuto.conteudoEmailSegundaAlcada;
    this.conteudoEmailTerceiraAlcada = configOcorrenciaAuto.conteudoEmailTerceiraAlcada;
    this.dataAteReincidencia = configOcorrenciaAuto.dataAteReincidencia;
  }

  modeloCompleto(): boolean {
    return this.rotinaCliente !== undefined && this.criterioAvaliacaoRotinaCliente !== undefined;
  }

  getNewInstance(object?: any): ConfigOcorrenciaAuto {
    return new ConfigOcorrenciaAuto(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/config-ocorrencia-auto.ts